import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/tokens.css';
import './design/app.css';
import { installWallpaper } from './design/wallpaper';
import { language, setLanguage } from './i18n/i18n';
import { App } from './ui/App';
import { applyTheme, storedTheme } from './ui/theme';

applyTheme(storedTheme());
setLanguage(language());
installWallpaper();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
